<template>
  <div class="work-pool-container">
    <el-row :gutter="20">
      <!-- 左侧状态栏 -->
      <el-col :span="4">
        <div class="state-sidebar">
          <ul class="state-list">
            <li
              v-for="(item, index) in states"
              :key="index"
              class="state-item"
              :class="{ 'active-state': conditions.state === item.state }"
              @click="switchWorkState(item)"
            >
              {{
                item.state === ""
                  ? "全部"
                  : item.state === "W"
                  ? "待处理"
                  : "处理完成"
              }}
            </li>
          </ul>
        </div>
      </el-col>

      <!-- 右侧内容区 -->
      <el-col :span="20">
        <!-- 搜索卡片 -->
        <el-card class="search-card">
          <div slot="header" class="flex justify-between">
            <span>工单搜索</span>
          </div>

          <el-form :model="conditions" class="search-form" label-width="80px">
            <!-- 第一行 -->
            <el-row :gutter="15" style="margin-bottom: 10px">
              <el-col :span="6">
                <el-form-item label="任务名称">
                  <el-input
                    v-model="conditions.workNameLike"
                    placeholder="请输入任务名称"
                    clearable
                    style="width: 100%"
                    @input="handleConditionChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="任务状态">
                  <el-select
                    v-model="conditions.state"
                    placeholder="请选择任务状态"
                    clearable
                    style="width: 100%"
                    @change="handleConditionChange"
                  >
                    <el-option label="全部" value="" />
                    <el-option label="待处理" value="W" />
                    <el-option label="处理完成" value="C" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="任务类型">
                  <!-- 替换为级联选择器 -->
                  <el-cascader
                    v-model="conditions.wtIds"
                    :options="cascaderWorkTypes"
                    placeholder="请选择任务类型"
                    clearable
                    style="width: 100%"
                    :props="{
                      value: 'wtId',
                      label: 'typeName',
                      children: 'children',
                      checkStrictly: true, // 允许选择任意一级
                      expandTrigger: 'click',
                    }"
                    @change="handleWorkTypeChange"
                    popper-class="work-type-cascader"
                    :popper-append-to-body="true"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="处理人">
                  <el-input
                    v-model="conditions.staffNameLike"
                    placeholder="请输入处理人"
                    clearable
                    style="width: 100%"
                    @input="handleConditionChange"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第二行 -->
            <el-row :gutter="15" style="margin-bottom: 10px">
              <el-col :span="6">
                <el-form-item label="所属园区">
                  <el-select
                    v-model="conditions.communityId"
                    placeholder="请选择所属园区"
                    clearable
                    style="width: 100%"
                    filterable
                    remote
                    :remote-method="getParkList"
                    :loading="parkLoading"
                    @change="handleCommunityChange"
                  >
                    <el-option
                      v-for="park in parkList"
                      :key="park.communityId"
                      :label="park.storeName"
                      :value="park.communityId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="所属部门">
                  <el-select
                    v-model="conditions.deptId"
                    placeholder="请选择所属部门"
                    clearable
                    style="width: 100%"
                    filterable
                    :loading="deptLoading"
                    @change="handleDeptChange"
                  >
                    <el-option
                      v-for="dept in deptList"
                      :key="dept.deptId"
                      :label="dept.deptName"
                      :value="dept.deptId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发起人">
                  <el-select
                    v-model="conditions.createUserId"
                    placeholder="请选择发起人"
                    clearable
                    style="width: 100%"
                    filterable
                    :loading="userLoading"
                    :disabled="!conditions.deptId"
                    @change="handleConditionChange"
                  >
                    <el-option
                      v-for="user in creatorList"
                      :key="user.userId"
                      :label="user.userName"
                      :value="user.userId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="紧急程度">
                  <el-select
                    v-model="conditions.urgencyLevel"
                    placeholder="请选择"
                    clearable
                    style="width: 100%"
                    @change="handleConditionChange"
                  >
                    <el-option label="重点" value="1001" />
                    <el-option label="紧急" value="1002" />
                    <el-option label="普通" value="1003" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第三行 -->
            <el-row :gutter="15">
              <el-col :span="6">
                <el-form-item label="开始时间">
                  <el-date-picker
                    v-model="conditions.queryStartTime"
                    type="date"
                    placeholder="请选择开始时间"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    @change="handleConditionChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="结束时间">
                  <el-date-picker
                    v-model="conditions.queryEndTime"
                    type="date"
                    placeholder="请选择结束时间"
                    value-format="yyyy-MM-dd"
                    :picker-options="endDateOptions"
                    style="width: 100%"
                    @change="handleConditionChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" class="flex align-center justify-end pt10">
                <el-button
                  type="primary"
                  @click="handleSearch"
                  style="margin-right: 10px"
                >
                  搜索
                </el-button>
                <el-button @click="handleReset"> 重置 </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>

        <!-- 列表卡片 -->
        <el-card class="work-list-card">
          <div slot="header" class="flex justify-between">
            <span>工单列表</span>
            <div>
              <el-button
                type="primary"
                size="small"
                @click="exportWork"
                style="margin-right: 10px"
              >
                <i class="el-icon-download"></i>
                导出
              </el-button>
              <el-button
                type="success"
                icon="el-icon-download"
                size="small"
                @click="batchDownloadFiles"
                :disabled="!selectedWorks.length"
              >
                批量下载
              </el-button>
            </div>
          </div>

          <el-table
            v-loading="loading"
            :data="workPoolInfo.works"
            border
            style="width: 100%"
            :default-width="120"
            @selection-change="handleSelectionChange"
            ref="workTable"
          >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column prop="workId" label="工单ID" align="center" />
            <el-table-column
              prop="workName"
              label="工单名称"
              align="center"
              min-width="150"
            />
            <el-table-column prop="typeName" label="工单类型" align="center" />
            <el-table-column
              label="紧急程度"
              prop="urgencyLevel"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  v-if="getUrgencyText(scope.row.urgencyLevel)"
                  :type="getUrgencyTagType(scope.row.urgencyLevel)"
                  size="small"
                >
                  {{ getUrgencyText(scope.row.urgencyLevel) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="内容" align="center" min-width="200">
              <template slot-scope="scope">
                <div
                  class="text-ellipsis"
                  :title="
                    getJoinContentsWithIndex(scope.row.contents) || '无内容'
                  "
                >
                  {{ getJoinContentsWithIndex(scope.row.contents) || "-" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="执行周期" align="center">
              <template slot-scope="scope">
                {{ scope.row.workCycle === "1001" ? "一次性" : "周期性" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="createUserName"
              label="创建人"
              align="center"
            />
            <el-table-column prop="curStaffName" label="处理人" align="center">
              <template slot-scope="scope">
                {{ scope.row.curStaffName || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="curCopyName" label="抄送人" align="center">
              <template slot-scope="scope">
                {{ scope.row.curCopyName || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="stateName" label="工单状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.stateName }}
                <span
                  v-if="
                    scope.row.state === 'C' && scope.row.taskTimeout === 'Y'
                  "
                >
                  (超时)
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              align="center"
              min-width="180"
            />
            <el-table-column label="操作" align="center" min-width="120">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="_toWorkDetailPage(scope.row)"
                >
                  详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            :current-page="pagination.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.size"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 20px; text-align: right"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryStartWork, exportWorkData } from "@/api/oa/startWorkApi";
import { getCommunityId } from "@/api/community/communityApi";
import { listWorkType } from "@/api/oa/editWorkApi";
import { listCommunitys } from "@/api/community/communityApi";
import { listOrgTree } from "@/api/work/repairTypeUserApi";
import { getStaffInfos } from "@/api/work/repairTypeUserApi";

// 定义 localStorage 的 key
const STORAGE_KEY = "workPoolList_search_condition_v1";

// 防抖函数：避免频繁保存
function debounce(func, wait = 300) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

export default {
  name: "WorkPoolList",
  data() {
    return {
      loading: false,
      communityId: "",
      // 园区/部门/发起人相关
      parkLoading: false,
      parkList: [],
      parkPage: { current: 1, size: 100, total: 0 },
      orgs: [],
      deptLoading: false,
      deptList: [],
      userLoading: false,
      creatorList: [],
      // 工作类型列表 - 新增级联适配数据
      workTypes: [],
      cascaderWorkTypes: [], // 适配级联选择器的任务类型数据
      // 状态列表
      states: [
        { state: "", name: "all" },
        { state: "W", name: "pending" },
        { state: "C", name: "completed" },
      ],
      // 筛选条件 - 新增级联选择的ID数组
      conditions: {
        state: "",
        workNameLike: "",
        createUserNameLike: "",
        staffNameLike: "",
        queryStartTime: "",
        queryEndTime: "",
        page: 1,
        row: 10,
        communityId: "",
        deptId: "",
        createUserId: "",
        wtIds: [], // 级联选择的ID数组
        wtId: "", // 实际查询用的单ID
        urgencyLevel: "",
      },
      // 工单数据 + 分页
      workPoolInfo: { works: [] },
      pagination: { current: 1, size: 10, total: 0 },
      // 结束时间禁用配置
      endDateOptions: {
        disabledDate: (time) => {
          if (this.conditions.queryStartTime) {
            return (
              time.getTime() <
              new Date(this.conditions.queryStartTime).setHours(0, 0, 0, 0)
            );
          }
          return false;
        },
      },
      // 选中的工单列表
      selectedWorks: [],
      // OSS 基础域名
      ossBaseUrl: "https://djwenjiancucun.oss-cn-beijing.aliyuncs.com/",
      // 防抖后的保存方法
      debouncedSave: null,
    };
  },
  created() {
    this.communityId = getCommunityId();
    // 初始化防抖保存方法
    this.debouncedSave = debounce(this.saveSearchCondition, 300);

    // 【核心】尝试从 localStorage 恢复搜索条件
    const hasRestored = this.loadSearchCondition();

    if (hasRestored) {
      // 如果恢复了数据，确保 communityId 有值
      if (!this.conditions.communityId) {
        this.conditions.communityId = this.communityId;
      }
      // 恢复后直接加载列表和基础数据
      this._listWorkTypes();
      this.getParkList();
      this.getDeptList();
      this._listWorkPools();
    } else {
      // 首次访问，执行原有初始化逻辑
      this.conditions.communityId = this.communityId;
      this._listWorkTypes();
      this.getParkList();
      this.getDeptList();
      this._listWorkPools();
    }
  },
  methods: {
    // --- 缓存管理方法 ---
    saveSearchCondition() {
      const dataToSave = {
        conditions: JSON.parse(JSON.stringify(this.conditions)),
        pagination: JSON.parse(JSON.stringify(this.pagination)),
      };
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(dataToSave));
      } catch (e) {
        console.warn("LocalStorage 保存失败", e);
      }
    },

    loadSearchCondition() {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed.conditions) {
            this.conditions = { ...this.conditions, ...parsed.conditions };
            // 兼容后端返回的 ALL 状态
            if (this.conditions.state === "ALL") {
              this.conditions.state = "";
            }
            // 兼容旧的wtId缓存，转换为级联格式
            if (this.conditions.wtId && !this.conditions.wtIds.length) {
              this.conditions.wtIds = [this.conditions.wtId];
            }
          }
          if (parsed.pagination) {
            this.pagination = { ...this.pagination, ...parsed.pagination };
          }
          return true;
        }
      } catch (e) {
        console.warn("LocalStorage 读取失败", e);
        localStorage.removeItem(STORAGE_KEY);
      }
      return false;
    },

    clearSearchCondition() {
      localStorage.removeItem(STORAGE_KEY);
    },

    // 条件变化时触发保存（防抖）
    handleConditionChange() {
      this.debouncedSave();
    },

    // --- 新增：级联选择器变更事件 ---
    handleWorkTypeChange(value) {
      // 取最后一个ID作为查询用的wtId
      this.conditions.wtId =
        value && value.length > 0 ? value[value.length - 1] : "";
      // 触发条件保存
      this.handleConditionChange();
    },

    // --- 业务方法 ---
    getJoinContentsWithIndex(contents) {
      if (!contents || !Array.isArray(contents) || contents.length === 0) {
        return "";
      }
      const contentItems = contents
        .map((item, index) => {
          const content = item.content || "";
          return content ? `内容${index + 1}：${content}` : "";
        })
        .filter((item) => item);
      return contentItems.join(",");
    },
    getUrgencyText(level) {
      const levelMap = { 1001: "重点", 1002: "紧急", 1003: "普通" };
      return levelMap[level];
    },
    getUrgencyTagType(level) {
      const typeMap = { 1001: "danger", 1002: "warning", 1003: "success" };
      return typeMap[level];
    },
    handleSelectionChange(val) {
      this.selectedWorks = val;
    },
    batchDownloadFiles() {
      if (!this.selectedWorks.length) {
        this.$message.warning("请先选择需要下载的工单");
        return;
      }
      let totalFileCount = 0;
      const allValidFiles = [];
      this.selectedWorks.forEach((work, workIndex) => {
        if (
          work.pathUrls &&
          typeof work.pathUrls === "string" &&
          work.pathUrls.trim().length > 0
        ) {
          allValidFiles.push({
            path: work.pathUrls.trim(),
            workId: work.workId,
            fileIndex: workIndex,
          });
          totalFileCount++;
        }
      });
      if (totalFileCount === 0) {
        this.$message.info("选中的工单暂无可下载文件");
        return;
      }
      let downloadFailCount = 0;
      allValidFiles.forEach((fileItem) => {
        try {
          const fullDownloadUrl = fileItem.path.startsWith("http")
            ? fileItem.path
            : `${this.ossBaseUrl}${fileItem.path}`;
          const link = document.createElement("a");
          link.href = fullDownloadUrl;
          const fileName =
            fileItem.path.split("/").pop() || `工单${fileItem.workId}_文件`;
          link.download = fileName;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          setTimeout(() => document.body.removeChild(link), 100);
        } catch (error) {
          console.error("下载失败:", error);
          downloadFailCount++;
        }
      });
      if (downloadFailCount > 0) {
        this.$message.warning(`批量下载完成，${downloadFailCount}个文件失败`);
      } else {
        this.$message.success(`成功下载${totalFileCount}个文件`);
      }
    },
    async exportWork() {
      try {
        const useCommunityId = this.conditions.communityId || this.communityId;
        const params = {
          ...this.conditions,
          pagePath: "workPoolList",
          state: this.conditions.state === "" ? "ALL" : this.conditions.state,
          communityId: useCommunityId,
          page: undefined,
          row: undefined,
        };
        await exportWorkData(params);
        this.$message.success("导出成功，请到下载中心查看");
        this.$router.push("/pages/property/downloadTempFile?tab=下载中心");
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("导出失败，请稍后重试");
      }
    },
    async _listWorkPools() {
      this.loading = true;
      try {
        const useCommunityId = this.conditions.communityId || this.communityId;
        const params = {
          state: this.conditions.state === "" ? "ALL" : this.conditions.state,
          workName: this.conditions.workNameLike,
          staffName: this.conditions.staffNameLike,
          wtId: this.conditions.wtId, // 依然使用单ID查询，保持和后端兼容
          queryStartTime: this.conditions.queryStartTime,
          queryEndTime: this.conditions.queryEndTime,
          page: this.pagination.current,
          row: this.pagination.size,
          communityId: useCommunityId,
          deptId: this.conditions.deptId,
          createUserId: this.conditions.createUserId,
          urgencyLevel: this.conditions.urgencyLevel,
        };
        const { data, total } = await queryStartWork(params);
        this.workPoolInfo.works = data || [];
        this.pagination.total = total || 0;
      } catch (error) {
        console.error("获取工单列表失败:", error);
        this.$message.error("获取工单列表失败");
      } finally {
        this.loading = false;
      }
    },
    // --- 修改：适配级联选择器的任务类型加载 ---
    async _listWorkTypes() {
      try {
        const res = await listWorkType({
          page: 1,
          row: 100,
          communityId: this.communityId,
        });
        this.workTypes = res.data || [];

        // 转换为级联选择器需要的格式
        this.cascaderWorkTypes = this.workTypes.map((item) => ({
          wtId: item.wtId,
          typeName: item.typeName,
          children: item.children || [], // 兼容有无子节点的情况
        }));

        console.log("级联任务类型数据:", this.cascaderWorkTypes); // 调试用
      } catch (error) {
        console.error("获取工作单类型失败:", error);
      }
    },
    async getParkList(query = "") {
      this.parkLoading = true;
      try {
        const res = await listCommunitys({
          page: this.parkPage.current,
          row: this.parkPage.size,
          storeName: query,
        });
        this.parkList = res.data || [];
        this.parkPage.total = res.total || 0;
      } catch (error) {
        console.error("获取园区列表失败:", error);
      } finally {
        this.parkLoading = false;
      }
    },
    async getDeptList() {
      try {
        this.deptLoading = true;
        const communityId = this.conditions.communityId || this.communityId;
        const response = await listOrgTree({ communityId });
        if (response.code === 0) {
          this.orgs = [response.data];
          this.deptList = this.extractDeptListFromOrgTree(this.orgs);
        }
      } catch (error) {
        console.error("加载部门列表失败:", error);
      } finally {
        this.deptLoading = false;
      }
    },
    extractDeptListFromOrgTree(orgTree) {
      let deptList = [];
      if (!orgTree || !Array.isArray(orgTree)) return deptList;
      orgTree.forEach((node) => {
        if (node.id) {
          deptList.push({
            deptId: node.id,
            deptName: node.text,
            allOrgName: node.allOrgName,
          });
        }
        if (node.children && node.children.length > 0) {
          deptList = [
            ...deptList,
            ...this.extractDeptListFromOrgTree(node.children),
          ];
        }
      });
      return deptList;
    },
    async handleDeptChange(deptId) {
      // 部门变更时先保存条件
      this.handleConditionChange();

      this.conditions.createUserId = "";
      if (!deptId) {
        this.creatorList = [];
        return;
      }
      this.userLoading = true;
      try {
        const response = await getStaffInfos({
          orgId: deptId,
          row: 50,
          page: 1,
        });
        const staffs = response.staffs || [];
        this.creatorList = staffs.map((staff) => ({
          userId: staff.userId,
          userName: staff.userName,
          realName: staff.name,
        }));
      } catch (error) {
        console.error("加载发起人列表失败:", error);
        this.creatorList = [];
      } finally {
        this.userLoading = false;
      }
    },
    async handleCommunityChange() {
      // 园区变更时先保存条件
      this.handleConditionChange();

      this.conditions.deptId = "";
      this.conditions.createUserId = "";
      this.creatorList = [];
      this.getDeptList();
    },
    handleSearch() {
      this.pagination.current = 1;
      this._listWorkPools();
    },
    handleReset() {
      // 清除缓存
      this.clearSearchCondition();

      // 重置数据 - 新增重置wtIds
      this.conditions = {
        state: "",
        workNameLike: "",
        createUserNameLike: "",
        staffNameLike: "",
        queryStartTime: "",
        queryEndTime: "",
        page: 1,
        row: 10,
        communityId: this.communityId,
        deptId: "",
        createUserId: "",
        wtIds: [], // 重置级联选择
        wtId: "", // 重置查询用ID
        urgencyLevel: "",
      };
      this.creatorList = [];
      this.getDeptList();
      this.pagination = { current: 1, size: 10, total: 0 };

      if (this.$refs.workTable) {
        this.$refs.workTable.clearSelection();
      }
      this._listWorkPools();
    },
    switchWorkState(item) {
      this.conditions.state = item.state;
      this.pagination.current = 1;
      if (this.$refs.workTable) {
        this.$refs.workTable.clearSelection();
      }
      // 状态切换时保存条件
      this.handleConditionChange();
      this._listWorkPools();
    },
    _toWorkDetailPage(work) {
      this.$router.push(`/views/oa/workDetail?workId=${work.workId}`);
    },
    handleSizeChange(size) {
      this.pagination.size = size;
      if (this.$refs.workTable) this.$refs.workTable.clearSelection();
      // 分页大小变化时保存条件
      this.handleConditionChange();
      this._listWorkPools();
    },
    handleCurrentChange(current) {
      this.pagination.current = current;
      if (this.$refs.workTable) this.$refs.workTable.clearSelection();
      // 页码变化时保存条件
      this.handleConditionChange();
      this._listWorkPools();
    },
  },
};
</script>

<style lang="scss" scoped>
.work-pool-container {
  padding: 15px;

  .state-sidebar {
    background-color: #fff;
    border-radius: 4px;
    padding: 10px 0;
    height: 100%;

    .state-list {
      list-style: none;
      padding: 0;
      margin: 0;

      .state-item {
        padding: 12px 15px;
        cursor: pointer;
        text-align: center;
        transition: all 0.3s;
        font-size: 14px;

        &:hover {
          background-color: #f5f7fa;
        }

        &.active-state {
          background-color: #409eff;
          color: #fff;
        }
      }
    }
  }

  .search-card {
    margin-bottom: 15px;
    padding: 15px;

    .search-form {
      .el-form-item {
        margin-bottom: 0;
        label {
          font-size: 13px;
          font-weight: 500;
        }
      }
      .pt10 {
        padding-top: 10px;
      }
    }
  }

  .work-list-card {
    padding: 15px;

    .el-table {
      margin-top: 10px;
      font-size: 13px;

      .text-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
      }
    }
  }

  .flex {
    display: flex;
  }
  .align-center {
    align-items: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-end {
    justify-content: flex-end;
  }
}

/* 级联选择器样式优化 */
::v-deep .work-type-cascader {
  z-index: 9999 !important;
  width: 400px !important;

  .el-cascader-menu {
    height: auto !important;
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>
